<template>
<div>
<div class="container pad-yellow-background module-header">account info</div>


  <div class="container">
        <div class="row">

<div class="col-sm-6">
  <br>
  <b>email:</b><br>
{{user.user.email}}
  </div>
    </div>
    
    
    <div class="row">


      

<div class="col-sm-6">

      <div class="address" v-if="!updateDelivery"> <br>
<b>delivery address:</b><br>
<template v-if="user && user.user.deliveryAddress">
{{user.user.deliveryAddress.name}}<br>
{{user.user.deliveryAddress.phone}}<br>
{{user.user.deliveryAddress.addressLine1}}<br>
{{user.user.deliveryAddress.addressLine2}}<br>
{{user.user.deliveryAddress.city}}&nbsp;{{user.user.deliveryAddress.state}}&nbsp;{{user.user.deliveryAddress.zip}}
</template>
<br><br>
<button class="sm-button" @click="updateDelivery = true">update delivery address</button>
<br><br>

        <button class="mt10 fw" style="margin-top:20px;" id="cip-pay-btn" @click="cippaybuttoncreditsave">credit save</button>
</div>
<br>
<form @submit.prevent="checkForm" v-if="updateDelivery">
  <!-- <p v-if="errors.length">
    <b>Please correct the following error(s):</b>
    <ul>
      <li :key="error" v-for="error in errors">{{ error }}</li>
    </ul>
  </p> -->

<b>delivery address:</b>
 <br>
  <p>
    <input
      id="name"
      v-model="deliveryAddress.name"
      type="text"
      name="name"
      placeholder="add name"
      class="add-name-field"
    >
    <br>
    <input
      id="phone"
      v-model="deliveryAddress.phone"
      type="text"
      name="phone"
      placeholder="(555) 555-5555"
      class="add-phone-field"
    >
    <br>

    <input
      id="addressLine1"
      v-model="deliveryAddress.addressLine1"
      type="text"
      name="addressLine1"
      placeholder="add addressLine1"
      class="add-addressLine1-field"
    >
    <br>
        <input
      id="addressLine2"
      v-model="deliveryAddress.addressLine2"
      type="text"
      name="addressLine2"
      placeholder="add addressLine2"
      class="add-addressLine2-field"
    >
    <br>
    <input
      id="city"
      v-model="deliveryAddress.city"
      type="text"
      name="city"
      placeholder="add city"
      class="add-city-field"
    >
    <br>
      <input
      id="state"
      v-model="deliveryAddress.state"
      type="text"
      name="state"
      placeholder="add state"
      class="add-state-field"
    >
    <br>
      <input
      id="state"
      v-model="deliveryAddress.zip"
      type="text"
      name="zip"
      placeholder="add zip"
      class="add-zip-field"
    >


    &nbsp;&nbsp;&nbsp;
    <button class="sm-button add-delivery-address-button" type="submit" value="Submit">
   submit
      </button>

  </p>
</form>
<button class="sm-button" v-if="updateDelivery" @click="updateDelivery = false">cancel</button>
<br><br>
    </div>

    <div class="col-sm-6">


<br>

      <div class="address" v-if="!updateBilling">
<b>billing address:</b> <br />
<template v-if="user && user.user.billingAddress">
{{user.user.billingAddress.name}}<br>
{{user.user.billingAddress.addressLine1}}<br>
{{user.user.billingAddress.addressLine2}}<br>
{{user.user.billingAddress.city}}&nbsp;{{user.user.billingAddress.state}}&nbsp;{{user.user.billingAddress.zip}}
</template>
<br><br>
<button class="sm-button" @click="updateBilling = true">update billing address</button>
<br><br>
</div>
<br>
<form @submit.prevent="checkFormBilling" v-if="updateBilling">
<b>billing address:</b>
 <br />
 <br />
  <p>
    <input
      id="nameBilling"
      v-model="billingAddress.name"
      type="text"
      name="name"
      placeholder="add name"
      class="add-name-field"
    >
    <br>

  
    <input
      id="addressLine1Billing"
      v-model="billingAddress.addressLine1"
      type="text"
      name="addressLine1"
      placeholder="add addressLine1"
      class="add-addressLine1-field"
    >
    <br>
        <input
      id="addressLine2Billing"
      v-model="billingAddress.addressLine2"
      type="text"
      name="addressLine2"
      placeholder="add addressLine2"
      class="add-addressLine2-field"
    >
    <br>
    <input
      id="cityBilling"
      v-model="billingAddress.city"
      type="text"
      name="city"
      placeholder="add city"
      class="add-city-field"
    >
    <br>
      <input
      id="stateBilling"
      v-model="billingAddress.state"
      type="text"
      name="state"
      placeholder="add state"
      class="add-state-field"
    >
    <br>
      <input
      id="zipBilling"
      v-model="billingAddress.zip"
      type="text"
      name="zip"
      placeholder="add zip"
      class="add-zip-field"
    >


    &nbsp;&nbsp;&nbsp;
<button class="sm-button add-billing-address-button" type="submit" value="Submit">
   submit
      </button>

  </p>
</form>
<button class="sm-button" v-if="updateBilling" @click="updateBilling = false">cancel</button>
<br><br>
    </div>











    <div class="row" style="display:none;">
     <pre>
      {{user}}
     </pre>
    </div>
 </div>  </div>
    </div>
</template>


<script type="text/javascript">
import Submit from "@/components/svgIcons/Submit";
import Check from "@/components/svgIcons/Check";
import swal from "sweetalert";
export default {
  components: {
    Check,
    Submit
  },
  data() {
    return {
      user: {},
      updateBilling: false,
      updateDelivery: false,
      savedDeliveryAddress: {},
      savedBillingAddress: {},
      user: null,
      listBalance: "",
      currentBalance: "",
      amountUse: "",
      cardNumberInput: "",
      showInsufficientFunds: false,
      errors: [],
      giftcards: null,
      messageBody: {
        number: null,
        email: this.emailAddress
    },
deliveryAddress: {
  name: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  zip: ''
},
billingAddress: {
  name: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  zip: ''
},
  preferredGiftCard: ""
    }
    },
props: ['emailAddress'],
  methods: {
    cippaybuttoncreditsave() {

      let self = this;
      this.getCreditSaveToken().then(function (transactionToken) {
        emergepay.open({
          transactionToken: transactionToken,
          onTransactionSuccess: function (approvalData) {
            // console.log("Approval Data", approvalData);
            emergepay.close();

console.log('transasction success')
   if(self.title === 'Mamnoon'){

              if(self.$store.state.storeCurrentOrderUpdateMamnoon.preorder === true){
                self.scheduleAnOrder(self.$store.state.storeCurrentOrderUpdateMamnoon,approvalData,null);
              }
              
              if(self.$store.state.storeCurrentOrderUpdateMamnoon.preorder === false){
                self.doAnOrder(self.$store.state.storeCurrentOrderUpdateMamnoon,approvalData,null);
              }



    }else if(self.title === 'Mamnoon Street'){


              if(self.$store.state.storeCurrentOrderUpdateStreet.preorder === true){
                self.scheduleAnOrder(self.$store.state.storeCurrentOrderUpdateStreet,approvalData,null);
              }
              
              if(self.$store.state.storeCurrentOrderUpdateStreet.preorder === false){
                self.doAnOrder(self.$store.state.storeCurrentOrderUpdateStreet,approvalData,null);
              }



    }else if(self.title === 'Mbar'){


              if(self.$store.state.storeCurrentOrderUpdateMbar.preorder === true){
                self.scheduleAnOrder(self.$store.state.storeCurrentOrderUpdateMbar,approvalData,null);
              }
              
              if(self.$store.state.storeCurrentOrderUpdateMbar.preorder === false){
                self.doAnOrder(self.$store.state.storeCurrentOrderUpdateMbar,approvalData,null);
              }

    }
          },
          onTransactionFailure: function (failureData) {
            console.log("Failure Data", failureData);

            // console.log('transasction success')

          },
          onTransactionCancel: function () {
            console.log("transaction cancelled!");
          },
        });
      });
    },
    getCreditSaveToken() {
      let self = this;
      let dataToSend
   if(self.title === 'Mamnoon'){
      dataToSend = self.$store.state.storeCurrentOrderUpdateMamnoon
    }else if(self.title === 'Mamnoon Street'){
      dataToSend = self.$store.state.storeCurrentOrderUpdateStreet
    }else if(self.title === 'Mbar'){
      dataToSend = self.$store.state.storeCurrentOrderUpdateMbar
  }

      return new Promise(function (resolve, reject) {
        $.ajax({
          // url: "https://young-hamlet-03679.herokuapp.com/order/start-credit-save",
          url: "http://localhost:4000/order/start-credit-save",
          type: "POST",
          dataType: "json",
          contentType: "application/json",
          data: JSON.stringify(dataToSend),
        })
          .done(function (data) {
            if (data.transactionToken) resolve(data.transactionToken);
            else reject("Error getting transaction token");
          })
          .fail(function (err) {
            reject(err);
          });
      });
    },
    async checkFormBilling() {
          this.updateBilling = false
        try {
        let response = await this.$http.post("/user/submitbillingaddress", {
          email: this.emailAddress,
          billingAddress: this.billingAddress
          });
 console.log(response)
          this.savedBillingAddress = response.data.user.billingAddress
          // this.updateBilling = false

       
         } catch (err) {
        console.log(err.response);
      }
        this.getUser()
    },

async checkForm() {
 this.updateDelivery = false
        try {
        let response = await this.$http.post("/user/submitdeliveryaddress", {
          email: this.emailAddress,
          deliveryAddress: this.deliveryAddress
          });
this.savedDeliveryAddress = response.data.user.deliveryAddress
         } catch (err) {
        console.log(err.response);
      }

 this.getUser()
    },


        getUser() {
let self = this
      this.$http
        .get("/user/email/" + this.emailAddress)
        .then(function (response) {
          let userInfo = response.data;
          console.log(userInfo);
          self.user = userInfo
self.cardNumberInput = userInfo.user.giftcard
self.preferredGiftCard = userInfo.user.giftcard
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
  mounted() {
    this.getUser()

  },
};
</script>


<style lang="scss">


.address,
form{
  display: block;
    width: 100%;
}

.container.pad-yellow-background.module-header,
.module-header {
  width: 100%;
  display: block;
  background: #f05d5b !important;
  text-align: center;
  color: #fff367;
  padding: 15px;
  font-weight: 500;
  margin-bottom: 0;
}
.buttonStyle {
  border: 0;
  background: transparent;
  outline: none;
  padding-left: 0;
  padding-right: 0;
}
.buttonStyle:active,
.buttonStyle:visited,
.buttonStyle:focus {
  outline: none;
}
.placeholder {
  padding: 10px 10px 14px 10px;
  border: 0;
  border-radius: 0;
  font-weight: bold;
  // width: 250px;
      width: 300px;
}
.currBalance {
  padding: 20px;
  background: white;
  font-weight: bold;
}
.placeholder-balance {
    pointer-events: none;
    border: 0;
    width: 144px;
    padding: 10px 8px 10px 15px;
    font-size: 30px;
    font-weight: bold;
    color: black;
}
.button-panel {
  width: 100%;
&.bottom{
  width: 50%;
  margin: 0 auto;
}
&.top{
  width: 80%;
  margin: 0 auto;
}
.button-box {
    width: 50%;
    display: inline-block;
    text-align: center;
    &.text-left{
      text-align: left;
    }
  }
}
.placeholder::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #f58e58;
  opacity: 1; /* Firefox */
}

.placeholder:-ms-input-placeholder,
.placeholder::-ms-input-placeholder { /* Microsoft Edge */
  color: #f58e58;
}

.thick-grey{
  color: #49494a;
  font-size: 18px;
  font-weight: 600;
}

.container.pad-yellow-background.pd50,
.pd50{
  padding: 50px;
}

.pl50{
  padding-left: 50px;
}

@media only screen and (max-width: 1080px) {

.button-panel {
  width: 100%;
&.bottom{
  width: 100%;
  margin: 0 auto;
}

&.top{
  width: 100%;
  margin: 0 auto;
}

.button-box {

    width: 100%;
    display: inline-block;
    text-align: center;

    &.text-left{
      text-align: left;
    }

  }
}


.placeholder {
  width: 220px;
  margin: 0 auto;
  text-align: center !important;
}

.button-panel .button-box.text-center{
    text-align: center !important;
}



.button-panel .button-box.text-left{
   text-align: center !important;
}


.container.pad-yellow-background.pd50,
.pd50{
  padding: 50px 15px;
}


.moneytotal{
  padding-top: 40px;
}

.pl50{
  padding-left: 0;
}

}



@media only screen and (max-width: 480px){
.placeholder {
    width: 160px;

}
}

li{
// font-size: 10px;

 p{
  margin-bottom: 0;
}
}



.giftcards-list{
ul{
  max-height: 400px;
  border: 1px solid black;
  overflow: scroll;
  width: 90%;
  margin-top: 20px;
  padding-bottom: 40px;
  padding-top: 20px;
}
}

.module-header{
  width: 100%;
  display: block;
  background:#F05D5B;
  text-align: center;
  color: #fff367;
  padding: 10px;
  font-weight: bold;
  margin-bottom: 0;


  font-size:24px;
font-weight:500;
}


.buttonStyle{
    border: 0;
    background: transparent;
    outline: none;
}


.giftcard-item{
  // margin-bottom: 10px;
}

.cardnumber{
    padding: 10px 10px 14px 10px;
    border: 0;
    border-radius: 0;
    font-weight: bold;
}



#gift-card-table{

table{
    border-collapse:collapse;
    padding:0;
}
table td{
    // display:table-cell;
    vertical-align:top;

&:last-child{
padding-right: 0;



}



}

table td div{
    height:100%;
}

.w100{
  width: 100%;
      display: inline-table;
}

.w100{
  td{
    width: 33.33%;
        // display: inline-block;
  }
}


tr{
    border-bottom: 1px solid #cacaca;
}

tr td{
    padding: 18px 10px 15px 10px;
    height: 56px;
    margin-bottom: 0;


        display:table-cell;
    vertical-align:top;

&.primary{
    // background: #ddffdd;
    

}

}
}
.fl-right{
    float: right;
}



.disabled-b{

  background: #ffffff;
  color: #f05d5b;
  // border: 1px solid #f05d5b;


  margin-right: 10px !important;
}


.mr10{
   margin-right: 10px !important; 
}

@media only screen and (max-width: 768px) {

.hide-mob{
display: none !important;

}


.text-right-mob{
  text-align: right !important;
}

}



.add-giftcard-field{
    padding: 10px;
    border-radius: 10px;
    box-shadow: none;
    border: 1px solid grey;
}

.add-giftcard-button{
    padding: 3px 10px;
    border-radius: 4px;
    box-shadow: none;
    border: 1px solid transparent;
}



.giftcard-item.w100 td:first-child{
    padding-left: 0 !important;
}


th.w100{
  border-bottom: 1px solid #cacaca;
  padding-bottom: 20px;

  td{
    padding-bottom: 20px;  
  }
}



#gift-card-table tr:last-child {
    border-bottom: 0;
}

</style>


